import { Component, Input } from '@angular/core';

@Component({
  selector: 'sticker',
  template: `<label class="sticker" [style.background-color]="color">
  <ng-content></ng-content>
</label>
`,
  styles: [`.sticker{border-radius:10px;color:#fff;font-size:14px;margin:5px;padding:11px 25px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}icon{margin-right:5px;height:25px}`]
})
export class StickerComponent {

  @Input('color') color: string;
  @Input('text') text: string;
  @Input('icon') icon: string;
  @Input('stroke') stroke: boolean;

  constructor() {}
}
